import React, {Component} from 'react';
import {Field} from 'redux-form';
import RenderField from './RenderField';
import CustomIncomeDateSelect from './CustomIncomeDateSelect';
import TextWithLine from './TextWithLine';

class CheckStubForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show_secondary_row: false,
            full_remuneration: 0,
            discounts: 0

        }
        this.checkDiscountValue = this.checkDiscountValue.bind(this);
        this.renderDiscountField = this.renderDiscountField.bind(this);
        this.checkFullRemunerationValue = this.checkFullRemunerationValue.bind(this);
        this.renderFullRemunerationField = this.renderFullRemunerationField.bind(this);

    }

    checkDiscountValue(value){
        if ((value > (this.state.full_remuneration * 0.20))){
            this.setState({show_secondary_row: true, discounts: value});
        } else{
            this.setState({show_secondary_row: false, discounts: value});
            this.props.deleteReduxFormField(`${this.props.member}.loan_installment`);
            this.props.deleteReduxFormField(`${this.props.member}.foreclosures_amount`);
            this.props.deleteReduxFormField(`${this.props.member}.alimony`);
            this.props.deleteReduxFormField(`${this.props.member}.another_charges`);
        }
    }

    checkFullRemunerationValue(value){
        if ((value * 0.20) < this.state.discounts){
            this.setState({show_secondary_row: true, full_remuneration: value});
        } else{
            this.setState({show_secondary_row: false, full_remuneration: value});
            this.props.deleteReduxFormField(`${this.props.member}.loan_installment`);
            this.props.deleteReduxFormField(`${this.props.member}.foreclosures_amount`);
            this.props.deleteReduxFormField(`${this.props.member}.alimony`);
            this.props.deleteReduxFormField(`${this.props.member}.another_charges`);
        }
    }

    renderDiscountField(props){
        let customOnChange = (event) => {
            props.input.onChange(event);
            this.checkDiscountValue(event);
        }
        let field_props = Object.assign({}, props, {input: {...props.input, onChange: customOnChange}})
        return (<RenderField {...field_props}/>);
    }

    renderFullRemunerationField(props){
        let customOnChange = (event) => {
            props.input.onChange(event);
            this.checkFullRemunerationValue(event);
        }
        let field_props = Object.assign({}, props, {input: {...props.input, onChange: customOnChange}})
        return (<RenderField {...field_props}/>);
    }

    render(){
        let  {member, description} = this.props;
        const discounts_detail = (  <div>
                                    <div className='row'>
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <TextWithLine value='Detallá monto de los descuentos:'/>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-sm-12 col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <Field className="form-control" name={`${member}.loan_installment`} autoComplete="off" component={RenderField} type="currency" label="Cuotas Préstamos" />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <Field className="form-control" name={`${member}.alimony`} autoComplete="off" component={RenderField} type="currency" label="Cuotas Manuntención/Alimentos" />
                                            </div>
                                        </div>
                                    </div>
                                    </div>);
        return (<div >
                    <div className='row'>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <TextWithLine value={description}/>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <Field name={`${member}.remuneration_date`} props={{placeholder: 'Fecha'}} component={CustomIncomeDateSelect} label="Fecha Cobro"/>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <Field className="form-control"
                                       name={`${member}.full_remuneration`}
                                       autoComplete="off"
                                       component={this.renderFullRemunerationField}
                                       type="currency"
                                       label="Monto Bruto" />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <Field className="form-control"
                                       name={`${member}.discounts`}
                                       autoComplete="off"
                                       component={this.renderDiscountField}
                                       type="currency"
                                       label="Descuentos"/>
                            </div>
                        </div>
                    </div>
                    {this.state.show_secondary_row && discounts_detail}
                </div>
                );
    }
}



export default CheckStubForm;



/** WEBPACK FOOTER **
 ** ./src/components/CheckStubForm.js
 **/